import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://localhost:8000/api/v1", // localhost
    baseURL: 'https://appraiser-backend-qn4z.onrender.com/api/v1'    // vinek render account 
  // baseURL: "https://appraiser-i9so.onrender.com", // hosted yash account 
  // baseURL:'https://api.emadiappraisals.com/api/v1'
});

export default axiosInstance;
